import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.logo-marquee__splide' ).length ) {
        $( '.logo-marquee__splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: false,
            perPage: 1,
            gap: '70px',
            fixedWidth: '175px',
            arrows: false,
            pagination: false,
            autoScroll: {
              speed: .75,
              pauseOnFocus: false,
              pauseOnHover: false,
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
